import React, {Component} from 'react';

class SwitchButton extends Component {

    constructor(props) {
        super(props);

        this.state = {
            configSwitch: {...props.configSwitch}
        }
    }

    render() {
        return (
            <div className={this.state.configSwitch.classMain}>
                <div className={this.state.configSwitch.classCheckboxMain}>
                    <input id={this.state.configSwitch.id} type="checkbox" value={this.state.configSwitch.Seleccionado}/>
                        <label htmlFor={this.state.configSwitch.id}>
                            <div className={this.state.configSwitch?.classCheckbox} data-checked={this.state.configSwitch.checkedLabel} data-unchecked={this.props.configSwitch?.uncheckedLabel}></div>
                        </label>
                </div>
            </div>
        );
    }

    componentDidMount() {
        let myswitch = $('#' + this.state.configSwitch.id);
        myswitch.prop("checked", this.state.configSwitch.Seleccionado);

        //Observador de modificación.
        myswitch.on("change", (e) => {
            this.state.configSwitch.methodChange($(e.currentTarget).prop("checked"));
        });
    }

    componentDidUpdate(_prevProps, prevState) {
        if (this.props.configSwitch.Seleccionado !== prevState.configSwitch.Seleccionado) {
            let myswitch = $('#' + this.props.configSwitch.id);
            myswitch.prop("checked", this.props.configSwitch.Seleccionado);
            this.setState({
                configSwitch: {
                    ...this.state.configSwitch,
                    Seleccionado: this.props.configSwitch.Seleccionado
                }
            })
        }
    }

}

export default SwitchButton;
